/**
 * Chrome dispara este aviso quando um ResizeObserver causa relayout
 * no mesmo frame. É inofensivo, mas o overlay do CRA trata como erro fatal.
 */
export function isBenignResizeObserverError(message) {
  if (!message || typeof message !== 'string') return false;
  return (
    message.includes('ResizeObserver loop') ||
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded')
  );
}

/**
 * Impede que o overlay de desenvolvimento bloqueie a UI por esse ruído.
 * Chamar antes do ReactDOM.render.
 */
export function suppressBenignResizeObserverErrors() {
  if (typeof window === 'undefined') return;

  const shouldIgnore = (message) => isBenignResizeObserverError(message);

  window.addEventListener(
    'error',
    (event) => {
      if (shouldIgnore(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault?.();
      }
    },
    true
  );

  const previousOnError = window.onerror;
  window.onerror = function (message, ...rest) {
    if (shouldIgnore(typeof message === 'string' ? message : String(message))) {
      return true;
    }
    if (typeof previousOnError === 'function') {
      return previousOnError.call(this, message, ...rest);
    }
    return false;
  };
}
